import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Form, Row, Col, Input, Button} from 'antd'
import {PlusOutlined, SearchOutlined} from '@ant-design/icons'
import {withTranslation} from 'react-i18next'
import FormModal from './FormModal'
import UPM from '../../../../constants/urlPermissionMappings'
import {PAGE_SIZE_DEFAULT} from '../../../../constants/appConstant'
@inject('intelligentQueryStore')
@observer
class SearchForm extends Component {
  formRef = React.createRef()
  state = {
    addModalVisible: false,
  }
  componentDidMount() {
    const {intelligentQueryStore} = this.props
    intelligentQueryStore.onSqlExampleSearchAction({
      'page': 1,
      'size': PAGE_SIZE_DEFAULT,
      'question': ''
    })
  }
  handleSearch = () => {
    const {intelligentQueryStore} = this.props
    const fieldsValue = this.formRef.current.getFieldsValue()
    intelligentQueryStore.onSqlExampleSearchAction({
      'question': fieldsValue?.questionDesc || '',
      'page': 1,
      'size': PAGE_SIZE_DEFAULT,
    })
  }
  handleCreate = () => {
    this.setState({
      addModalVisible: true
    })
  }
  handleCancel = () => {
    this.setState({
      addModalVisible: false
    })
  }
  render() {
    const {location, t} = this.props
    return (
      <>
        <Form ref={this.formRef} size="middle" className="searchForm" layout="vertical">
          <div className="searchFormTitle">
            <SearchOutlined/> {t(`menu.${UPM.find(item => item.url === location?.pathname)?.pKey}`)}
          </div>
          <Row gutter={[10, 10]}>
            <Col span={6}>
              <Form.Item name="questionDesc" label={t(`intelligentQuery.questionDesc`)}
                rules={[{
                  message: `${t(`general.pleaseEnter`)} ${t(`intelligentQuery.questionDesc`)} ${t(`general.withoutSpecialChats`)}`,
                  pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                }]}
              >
                <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} allowClear/>
              </Form.Item>
            </Col>
            <Col span={18} style={{textAlign: 'right', marginTop: 30}}>
              <Button onClick={this.handleSearch} className="ant-btn-red">{t(`general.search`)}</Button>
              <Button onClick={this.handleCreate} type="primary" icon={<PlusOutlined/>}>{t(`general.add`)}</Button>
            </Col>
          </Row>
        </Form>
        {this.state.addModalVisible ? <FormModal
          addModalVisible={this.state.addModalVisible}
          handleCancel={this.handleCancel}
          title="add"
        /> : null}
      </>
    )
  }
}
export default withTranslation()(SearchForm)